import { Injectable } from '@angular/core';
import { RouterModule, ActivatedRoute, CanActivate, CanActivateChild, Router } from '@angular/router';

import { ApiService } from './shared/api.service';
 
@Injectable()
export class RouterGuard implements CanActivate {
    userCanActivate = false;
    currentUserRole = 'writer';
    limited = false;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private api: ApiService 
    ) {
        let user = api.getProp('user');
        if( user ) {
            this.currentUserRole = user.role;
            this.limited = user.limited.length > 0;
        }
    }
 
    canActivate(route, state) {
        let canActivate = true;
        let role = this.currentUserRole;
        if( route.firstChild && route.firstChild.data && route.firstChild.data.roles && (route.firstChild.data.roles.indexOf(role) === -1 || (this.limited === true && route.firstChild.data.limited)) ) {
            canActivate = false;
        }
        return canActivate;
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
}